import FocusItemsTable from "./components/FocusItemsTable";
import React from "react";

function FocusItems() {
  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <FocusItemsTable/>
          </div>
        </div>
      </div>

    </>
  )
}

export default FocusItems